import React, { Component } from 'react';

import './stars.scss';

class Stars extends Component {
  handleClick = () => {
    const { onClick, position, elementDimensions, max, canVote } = this.props;
      if (canVote) {

      const persentage = parseInt(position.x / elementDimensions.width * 1.1 * 100, 10);
      if (persentage > max) {
        onClick(max);
      } else if (persentage < 0) {
        onClick(0);
      }
      else {
        onClick(persentage);
      }
    }
  }

  render() {
    const { isActive, average, canVote } = this.props;
    const { persentage, elementDimensions, position, placeholderColor, starColor, numberOfElements, max } = this.props;
    const containerWidth = elementDimensions.width;
    let width;

    if (!isActive) {
      this.props.setPosition(0)
    }

    if (isActive && canVote) {
      width = position.x * 1.1
    } else {
      width = (average * containerWidth) / 100
    }

    if (width > elementDimensions.width) {
      width = elementDimensions.width;
    }

    return (
      <div className={`stars-rating-container ${canVote ? '': 'stars-disable'}`}>
        <div onClick={this.handleClick} onTouchEnd={this.handleClick}>
          <div className="stars-placeholder">
            {Array.from({length: numberOfElements}, (v, i) =><i key={`${i}str`} style={{color: placeholderColor || 'black'}} className="fa fa-star" aria-hidden="true"></i>)}
          </div>
          <div className={`stars ${canVote ? '': 'stars-disable'}`} style={{width: width ? `${width}px` : `${average}%`}}>
            {Array.from({length: numberOfElements}, (v, i) =><i key={`${i}str`} style={{color: starColor || '#f9c500'}} className="fa fa-star" aria-hidden="true"></i>)}
          </div>
        </div>
      </div>
    )
  }
}

export default Stars;


// WEBPACK FOOTER //
// ./src/components/stars/Stars.jsx